import {Component, OnInit} from '@angular/core';
import {FolderModel} from '../../../models/survey-monkey/folder.model';
import {SurveyModel} from '../../../models/survey-monkey/survey.model';
import {ClientEnum, ClientModel, LanguageModel} from '../../../models/survey/survey.model';
import {UsersService} from '../../users/users.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SurveyService} from '../surveys.service';
import {ToasterService} from 'angular5-toaster/dist';
import {ErrorMessageModel} from '../../../models/typeform/error-message.model';
import { ImportCSVService } from './import-csv.service';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { SurveyCSVModel } from '../../../models/import-csv/survey-csv.model';
import { ImportTemplate, ImportTemplateDetailModel } from '../../../models/import-csv/import-template.model';
import { ImportTemplateService } from './import-template.service';
import { ImportFromSystemType } from '../../../shared/constants/input.constants';
import { getAlphaCharFromIndex } from '../../../shared/helpers/string-helper';
import { TemplateType } from '../../../shared/constants/templateType.constants';
import { ImportResponseTraslationKey } from '../../../models/csvImportError/ImportResponseTraslationKey.model';
import { UserModel } from '../../../models/user/users.model';
import { AuthTokenService } from '../../../shared/services/auth-token.service';
import { LicenseTier } from '../../../models/license-tier/license-tier.model';
import { PreviousUrlService } from '../../../shared/services/previous-url.service';

@Component({
  selector: 'app-survey-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: ['./import-csv.component.less']
})
export class SurveyImportCSVComponent implements OnInit {

  folders: FolderModel[] = [];
  folderNames: string[] = [];
  surveys: SurveyModel[] = [];
  surveyNames: string[] = [];
  masterSurvey: SurveyModel = null;
  permissions = [
    {value: 'All', text: 'All Users'},
    {value: 'Admin', text: 'Admin Only'},
    {value: 'User', text: 'Selected Users'}
  ];
  importOptions = [
    {value: 'Replace', text: 'Replace all surveys/versions'},
    {value: 'Additional', text: 'Add additional surveys'},
  ];
  questionTypes = [
    {value: 'SingleChoice', text: 'Single Choice'},
    {value: 'MultipleChoice', text: 'Multiple Choice'},
    {value: 'Text', text: 'Long Text'},
    {value: 'YesNo', text: 'Yes/No'},
    {value: 'OpinionScale', text: 'Opinion Scale'},
    {value: 'Rating', text: 'Rating'},
    {value: 'Date', text: 'Date'},
    {value: 'Number', text: 'Numeric'},
    {value: 'Dropwdown', text: 'Dropwdown'},
    {value: 'WebLink', text: 'Web Link'},
    {value: 'Statement', text: 'Statement'},
    {value: 'GroupQuestions', text: 'Group Question'},
    {value: 'Omit', text: 'Omit'},
  ];
  childQuestionTypes = [
    {value: 'SingleChoice', text: 'Single Choice'},
    {value: 'MultipleChoice', text: 'Multiple Choice'},
    {value: 'Text', text: 'Long Text'},
    {value: 'YesNo', text: 'Yes/No'},
    {value: 'OpinionScale', text: 'Opinion Scale'},
    {value: 'Rating', text: 'Rating'},
    {value: 'Date', text: 'Date'},
    {value: 'Number', text: 'Numeric'},
    {value: 'Dropwdown', text: 'Dropwdown'},
    {value: 'WebLink', text: 'Web Link'},
    {value: 'Statement', text: 'Statement'},
    {value: 'Omit', text: 'Omit'},
  ];
  questionTypeClone: any;
  clients: ClientModel[] = [];
  clientNames: string[] = [];
  languages: LanguageModel[] = [];
  languageNames: string[] = [];

  isDesc = false;
  column = '';
  isSelectedAll = false;
  selectedSurveyVersionCount = 0;
  surveyVersions: SurveyModel[] = [];
  selectedPermission: any;
  selectedUserIds: number[] = [];
  users: any[] = [];
  isValid = false;
  importedSurveyCount = 0;

  selectedClient: ClientModel = null;
  showLoader = false;
  selectedFolderName: string;

  showOverrideSurvey = false;
  showSelectFiles = false;
  smErrorMessage = '';
  smErrorCode = '';
  hasErrorMessage = false;
  errorMessages: ErrorMessageModel[] = [];
  disabledMasterSurvey = true;
  showWarning = false;

  showTypeformNumberQuestionError = false;
  showTypeformContentQuestionError = false;
  countContentQuestionError = 0;
  errorMessagesApi = [];
  isSkipError = false;
  surveyItems: any[];
  uploader = new FileUploader({ url: '' });
  surveyId = null;
  isAnalyzeFile = false;
  files: File[];
  workSpaceSelected: any;
  templateSelected: any;
  importOption: string;
  masterSurveyNameSelected: string;
  surveyModels: SurveyCSVModel[];
  importTemplate: ImportTemplate;
  isShowDialogSaveTemplate = false;
  templates: ImportTemplate[];
  isNoLoadAnalyze = false;
  isShowConfirmImportDialog = false;
  readonly fileCSVExtention = '.csv';
  readonly fileExcelExtention = '.xlsx';
  surveyModelSelected: SurveyCSVModel;
  templateType = [TemplateType.EXISTING_TEMPLATE,TemplateType.NEW_TEMPLATE,TemplateType.TRANSLATION_KEY];
  isHideTemplate = true;
  isHideLanguage = true;
  isMultipleUpload = true;
  acceptedFiles = "";
  translationFile: File;
  showTranslationFile = false;
  showPopupError = false;
  errorTitle: string;
  errorMessage: string;
  responseTranslationKey: ImportResponseTraslationKey;
  responseTransKeyAndCsv: ImportResponseTraslationKey;
  hasTranslationKey = false;
  viewLogImportProcess = false;
  selectedTemplateType: string;
  client: ClientModel;
  currentUser: UserModel;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  clientDefault: string;
  
  constructor(private router: Router,
              private userService: UsersService,
              private toasterService: ToasterService,
              private importTemplateService: ImportTemplateService,
              private surveyService: SurveyService,
              private importCsvService: ImportCSVService,
              private shareService: PreviousUrlService,
              private route: ActivatedRoute) 
  {
    this.route.data.subscribe(data => {
        this.client = data.client;
    });
    this.currentUser = AuthTokenService.getUser();
  }

  ngOnInit(): void {
    if (!this.isAllowImportCSV()) {
        this.router.navigate(['surveys']);
    }
    this.shareService.setSurveyTitle('Survey Import');
    this.surveyService.getAllActiveClient().subscribe(res => {
      res = res.filter(f => f.licenseTier !== LicenseTier.BASIC);
      this.clients = res.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
      this.clientNames = this.clients.map(c => c.name);
      if (this.isAdmin) {
        this.clientDefault =  ClientEnum.INTERNAL;
        this.selectedClient = this.clients.find(x => x.name === this.clientDefault);
      } else {
        this.selectedClient = this.clients.find(x => x.id === this.currentUser.clientId)
        this.clientDefault =  this.selectedClient.name;
      }
      this.fetchSurveyData();
      this.fetchImportTemplates();
    });
    
    this.questionTypeClone = JSON.parse(JSON.stringify(this.questionTypes));
    this.files = [];
    this.files.push(null);

    this.surveyModels = [];
  }

  loadUserByClient(id) {
    this.userService.getAllByClient(id).subscribe(res => {
      this.users = res.sort((a, b) => a && b ? this.compareUser(a, b) : 0);
    });
  }

  fetchSurveyData() {
    this.showLoader = true;
    this.surveyItems = [];
    this.surveyItems.unshift({workspaceName: '(New Workspace)', id: null});
    this.surveyService.getSurveyImportBySystem(ImportFromSystemType.CSV, this.selectedClient.id).subscribe(
      (response) => {
        const temp = response;
        temp.sort((a, b) => a.workspaceName && b.workspaceName
          && a.workspaceName.toLowerCase() > b.workspaceName.toLowerCase() ? 1 : -1);
        this.surveyItems = this.surveyItems.concat(temp);
        this.showLoader = false;
      },
      (error) => {
        this.showLoader = false;
      }
    );
  }

  fetchImportTemplates() {
    this.importTemplateService.getImportTemplates(this.selectedClient.id).subscribe(res => {
      this.templates = res.sort((a, b) => a.templateName && b.templateName
          && a.templateName.toLowerCase() > b.templateName.toLowerCase() ? 1 : -1);
    });
  }

  isMaster(surveyName: string) {
    return surveyName === this.masterSurveyNameSelected;
  }

  sort(by: string) {
    this.isDesc = !this.isDesc;
    this.column = by;
    const direction = this.isDesc ? 1 : -1;
    this.surveyModels.sort((a, b) => a[by] < b[by] ? -1 * direction : direction);
  }

  compareUser(a, b) {
    return `${a.firstName} ${a.lastName}`.toLowerCase() > `${b.firstName} ${b.lastName}`.toLowerCase() ? 1 : -1;
  }

  onFolderChanged(event: any) {
    const folderName = event.value;
    this.selectedFolderName = folderName;
    const folderId = this.folders.find(x => x.title === folderName).id;
    this.disabledMasterSurvey = false;
    this.showLoader = true;
  }

  onSurveySelected(event: any) {
    const surveyName = event.value;
    const masterSurvey = this.surveys.find(s => s.title === surveyName);
    this.changeMasterSurvey(masterSurvey);
  }

  changeMasterSurvey(e) {
    this.masterSurvey = e;
    if (e) {
      this.surveyVersions = this.surveys.filter(s => s.id !== e.id);
      this.surveyVersions.forEach(s => {
        s.isChecked = s.isEnabled = true;
        if (s.questionCount < e.questionCount) {
          s.isLowerNumberQuestion = true;
        } else {
          s.isLowerNumberQuestion = false;
        }
      });
      this.calImportedSurveyCount();
    }
  }

  displayPermission(p) {
    return p ? p.text : null;
  }

  displayImportOption(p) {
    return p ? p.text : null;
  }

  displayQuestionType(p) {
    return p.text;
  }

  cancelSelectFilesDialog() {
    this.uploader.queue = [];
    this.showSelectFiles = false;
  }

  okSelectFilesDialog(isCsv:boolean) {
    if(isCsv){
      this.files = this.files.concat(this.uploader.queue.map(file => file._file));
      this.uploader.queue = [];
      this.showSelectFiles = false;
      if (this.files.length === 2) {
        this.masterSurveyNameSelected = this.files[1].name;
      }
      this.analyzeAndLoadQuestion();
    }else{
      if (this.uploader.queue.length > 0) {
        this.translationFile = this.uploader.queue[0]._file;
        this.uploader.queue = [];
        this.showSelectFiles = false;
        this.showTranslationFile = true;
      }
    }
  }

  onPermissionSelected(event: any) {
    if (this.selectedPermission && event.value.value !== this.selectedPermission.value) {
      this.selectedUserIds = [];
    }
    this.selectedPermission = event.value;
  }

  onSelectedClient(event: any) {
    const clientName = event.value;
    this.selectedClient = this.clients.find(x => x.name === clientName);
    this.fetchSurveyData();
    this.fetchImportTemplates();
    this.workSpaceSelected = null;
    this.loadUserByClient(this.selectedClient.id);
  }

  onAllSurveyVersionSelected(event: any) {
    this.surveyVersions.filter(s => s.isEnabled).forEach(s => s.isChecked = event);
    this.calImportedSurveyCount();
  }

  onSurveyVersionSelected(event: any, s: SurveyCSVModel) {
    s.isSelected = !s.isSelected;
  }

  displayUserExpr(s) {
    return `${s.firstName} ${s.lastName}`;
  }

  onUsersSelected(event) {
    this.selectedUserIds = event;
  }

  cancel() {
    this.router.navigate(['surveys']);
  }

  selectSurveyToCompare(event, s) {
    this.surveyModelSelected = s;
    if(this.isHideLanguage){
      this.compareWithSourceOfTruth();
    }else{
      //validate questions
      this.validateQuestions(s);
    }
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  compareWithSourceOfTruth() {
    if (this.importTemplate && this.surveyModelSelected) {
      const questionFromSourceTruth = this.getAllQuestionOfSourceOfTruth();
      const surveyQuestions = this.surveyModelSelected.questions;
      const length = Math.min(questionFromSourceTruth.length, surveyQuestions.length);
      const maxLength = Math.max(questionFromSourceTruth.length, surveyQuestions.length);
      for (let i = 0; i < maxLength ; i++) {
          if (i < length) {
            questionFromSourceTruth[i].isNotValid = questionFromSourceTruth[i].questionText !== surveyQuestions[i];
          } else if (i < questionFromSourceTruth.length) {
            questionFromSourceTruth[i].isNotValid = false;
          }
      }
    }
  }

  getAllQuestionOfSourceOfTruth() {
    const listQuestion = [];
    const questionFromSourceTruth = this.importTemplate.importTemplateDetailModels;
    if (questionFromSourceTruth && questionFromSourceTruth.length) {
      questionFromSourceTruth.forEach(question => {
        listQuestion.push(question);
        const childQuestions = question.importTemplateDetails;
        if (childQuestions && childQuestions.length) {
          childQuestions.forEach(child => {
            listQuestion.push(child);
          });
        }
      });
    }
    return listQuestion.sort((q1, q2) => q1.columnNumber > q2.columnNumber ? 1 : -1 );
  }

  import() {
    if (((this.workSpaceSelected && this.workSpaceSelected.id)
      || this.templateSelected
      || this.masterSurveyNameSelected) && this.files.length) {
      this.showLoader = true;
      const formData = new FormData();
      if(this.translationFile){
        formData.append("TranslationKeyFile",this.translationFile);
        formData.append('languagesBySurvey', JSON.stringify(this.responseTransKeyAndCsv != undefined ? this.responseTransKeyAndCsv.surveyLanguages: null));
        formData.append("isSavedTranslationKey", JSON.stringify(true));
        formData.append("isUsedTranslationKey", JSON.stringify(true));
      }else {
        formData.append("isSavedTranslationKey", JSON.stringify(false));
        formData.append("isUsedTranslationKey", JSON.stringify(this.hasTranslationKey));
        formData.append('languagesBySurvey', JSON.stringify(this.responseTransKeyAndCsv != undefined ? this.responseTransKeyAndCsv.surveyLanguages: null));
      }
      this.surveyModels.forEach( (survey, index) => {
        if (survey.isSelected) {
          formData.append('file', this.files[index + 1]);
        }
      });
      formData.append('clientId', this.selectedClient && this.selectedClient.id ? this.selectedClient.id.toString() : '');
      formData.append('workspaceSurveyMasterId', this.workSpaceSelected && this.workSpaceSelected.id ? this.workSpaceSelected.id : '');
      formData.append('templateId', this.templateSelected ? this.templateSelected : '');
      formData.append('masterSurveyName', this.masterSurveyNameSelected
        || !this.isReplaceSurvey() ? this.masterSurveyNameSelected : '');
      if(this.selectedPermission != null) {
        formData.append('permission', this.selectedPermission.value);
        formData.append('userIds', JSON.stringify(this.selectedUserIds));
      }
      formData.append('importTemplateDetailModels', JSON.stringify(this.importTemplate.importTemplateDetailModels) );

      formData.append('importOption', this.importOption);
      this.importCsvService.importProcess(formData).subscribe(res => {
        this.showLoader = false;
        if(res.isValid){
          this.toasterService.pop('success', 'Import successful');
          this.router.navigate(['surveys']);  
        } else {
          this.responseTransKeyAndCsv = res
          this.viewLogImportProcess = true;
        }
      });
    }
  }

  countNumberSurveyImport() {
    if (this.surveyModels && this.surveyModels.length) {
      return this.importedSurveyCount = this.surveyModels.filter(f => f.isSelected).length;
    }
    return 0;
  }

  private calImportedSurveyCount() {
    this.selectedSurveyVersionCount = this.surveyModels.filter(f => f.isSelected).length;
    this.importedSurveyCount = this.surveyModels.filter(f => f.isSelected).length;

    const enabledSurveyVersionCount = this.surveyVersions.filter(f => f.isEnabled).length;
    this.isSelectedAll = enabledSurveyVersionCount > 0 && enabledSurveyVersionCount === this.selectedSurveyVersionCount;
  }

  goToTypeform() {
    this.router.navigate(['surveys/import-typeform']);
  }

  selectAllSurveyVersion(e: any) {
    this.surveyModels.filter(f => !this.isMaster(f.name)).forEach(f => f.isSelected = e);
  }

  controlImportErrorDialog(isSkipNumberQuestionError = false, isSkipContentError = false) {
    if (this.isNumberQuestionError(this.errorMessagesApi) && !isSkipNumberQuestionError) {
      this.showTypeformNumberQuestionError = true;
    }
    else {
      const numberContentError = this.getNumberContentQuestionError(this.errorMessagesApi);
      if (numberContentError && !isSkipContentError) {
        this.countContentQuestionError = numberContentError;
        this.showTypeformContentQuestionError = true;
      } else {
        this.isSkipError = true;
        // this.import(false, true);
      }
    }
  }

  onChangeImportOption(data: any) {
    this.importOption = data.value;
    this.masterSurveyNameSelected = null;
    this.analyzeAndLoadQuestion();
  }

  getNumberContentQuestionError(listError: any) {
    return listError.filter(item => item.errorType === "QuestionContent").length;
  }

  isNumberQuestionError(listError: any) {
    return listError.filter(item => item.errorType === "NumberQuestion").length > 0;
  }

  goToSurveyMonkey() {
    this.router.navigate(['surveys/import-survey-monkey']);
  }

  onFilesUpload(files: File[]) {

    const listFile = this.uploader.queue;
    this.viewLogImportProcess = false;
    const fileNames = this.files.filter(file => file).map(file => file.name);
    let fileExtentionChose = "";
    if(this.acceptedFiles === this.fileCSVExtention){
      fileExtentionChose = this.fileCSVExtention;
    }else if(this.acceptedFiles === this.fileExcelExtention){
      fileExtentionChose = this.fileExcelExtention;
    }
    const fileValids = listFile.filter(file => {
        const fileName = file._file.name;
        const fileExtention = file._file.name.substring(fileName.length - fileExtentionChose.length, fileName.length);
        return fileExtention.toLowerCase() === fileExtentionChose && !fileNames.includes(fileName);
    });
    this.uploader.queue = fileValids;
    if(this.acceptedFiles === this.fileCSVExtention){
      this.verifyCsvFiles(fileValids);
    }else if(this.acceptedFiles === this.fileExcelExtention){
      this.verifyTranslationFile(fileValids);
    }
  }

  getMasterSurveyName() {
    return this.masterSurveyNameSelected;
  }

  onChangeSurvey(data: any) {
    this.masterSurveyNameSelected = data.value;
    this.setSelectedForMasterSurvey();
    this.templateSelected = null;
    if(this.isHideLanguage){
      this.analyzeAndLoadQuestion();
    }else{
      this.verifyAndLoadTranslationKey(this.translationFile);
    }
  }

  setSelectedForMasterSurvey() {
    if (this.surveyModels && this.surveyModels.length) {
      this.surveyModels.forEach( survey => {
        if (survey.name === this.masterSurveyNameSelected) {
          survey.isSelected = true;
        }
      });
    }
  }

  onChangeWorkspace(data: any) {
    this.workSpaceSelected = data.value;
    this.hasTranslationKey = this.workSpaceSelected.existTranslationKey;
    if(this.hasTranslationKey){
      this.selectedTemplateType = TemplateType.TRANSLATION_KEY;
      this.isHideLanguage = false;
    } else {
      this.hasTranslationKey = false
    }
    this.resetForm();
  }

  changeQuestionType(index: number, data: any) {
      this.importTemplate.importTemplateDetailModels[index].questionType = data.value;
      const listChild = this.importTemplate.importTemplateDetailModels[index].importTemplateDetails;
      if (this.importTemplate.importTemplateDetailModels[index].questionType !== 'MultipleChoice'
        && listChild && listChild.length) {
        listChild.forEach(child => child.questionType = child.oldType);
      }
  }

  changeQuestionChildType(index: number, childIndex: number, data: any) {
    this.importTemplate.importTemplateDetailModels[index].importTemplateDetails[childIndex].questionType = data.value;
  }

  isDisabledControl() {
    return !this.files || ! this.files.filter(file => file).length;
  }

  isSelectedWorkspace() {
    return this.workSpaceSelected && this.workSpaceSelected.id;
  }

  getTextFromQuestiontype(questionType: string) {
    let text = '';
    this.questionTypes.forEach(question => {
      if (question.value === questionType) {
        text = question.text;
      }
    });
    return text;
  }

  mapTemplateValue(data: any) {
    return data ? data.id : null;
  }

  onChangeTemplate(data: any) {
    this.templateSelected = data.itemData.id;
    this.analyzeAndLoadQuestion();
  }

  isSelectPermission() {
    return !this.surveyId && (this.selectedPermission
      && (this.selectedPermission.value !== 'User' || (this.selectedUserIds && this.selectedUserIds.length)));
  }

  isShowIconGroup(index: number) {
    const prevQuestionType = index !== 0 ? this.importTemplate.importTemplateDetailModels[index - 1].questionType : 'Omit';
    const questionType = this.importTemplate.importTemplateDetailModels[index].questionType;
    return (!this.workSpaceSelected || !this.workSpaceSelected.id)
      && index !== 0
      && (questionType !== 'Omit')
      && (prevQuestionType === 'GroupQuestions' || prevQuestionType === 'MultipleChoice')
      && !((questionType === 'MultipleChoice' && prevQuestionType === 'GroupQuestions')
      || (questionType === 'GroupQuestions' && prevQuestionType === 'MultipleChoice')
      || (questionType === 'MultipleChoice' && prevQuestionType === 'MultipleChoice'));
  }

  isDisabledText(child: ImportTemplateDetailModel, parent: ImportTemplateDetailModel) {
    return parent && parent.questionType === 'Omit' || child && child.questionType === 'Omit';
  }

  isReplaceSurvey() {
    return this.importOption === 'Replace';
  }

  isShowSaveTemplateBtn() {
    let showButton = this.importTemplate && (!this.workSpaceSelected || !this.workSpaceSelected.id);
    showButton = showButton && this.isHideLanguage;
    return showButton
  }

  isNotDisabledSaveTemplateBtn() {
    let isValid = (this.selectedPermission &&
                    (
                      this.selectedPermission.value !== 'User' ||
                      (this.selectedUserIds && this.selectedUserIds.length)
                    )
                  )

    if(!this.isHideTemplate){
      isValid = isValid && this.templateSelected;
    }
    return isValid;
  }

  isShowUpdateTemplateIcon() {
    let showButton = this.importTemplate && (!this.workSpaceSelected || !this.workSpaceSelected.id) && this.templateSelected;
    showButton = showButton && this.isHideLanguage;
    return showButton;
  }

  groupQuestion(index: number) {
    const templateQuestions = this.importTemplate.importTemplateDetailModels;
    const question = templateQuestions[index];
    const prevQuestion = templateQuestions[index - 1];
    if (!prevQuestion.importTemplateDetails) {
      prevQuestion.importTemplateDetails = [];
    }
    if (question.importTemplateDetails && question.importTemplateDetails.length) {
      const questionChilds = question.importTemplateDetails;
      question.importTemplateDetails = [];
      prevQuestion.importTemplateDetails.push(question);
      prevQuestion.importTemplateDetails = prevQuestion.importTemplateDetails.concat(questionChilds);
    } else {
      prevQuestion.importTemplateDetails.push(question);
    }
    if (prevQuestion.questionType === 'MultipleChoice') {
      question.oldType = question.questionType;
      question.questionType = 'AnswerChoice';
    }
    this.importTemplate.importTemplateDetailModels.splice(index, 1);
  }

  unGroupQuestion(index: number, poisition: number) {
    const templateQuestions = this.importTemplate.importTemplateDetailModels;
    const question = templateQuestions[index];
    const childQuestion = question.importTemplateDetails[poisition];
    if (question.questionType === 'MultipleChoice') {
      childQuestion.questionType = childQuestion.oldType;
    }
    templateQuestions.splice(index + 1, 0, childQuestion);
    question.importTemplateDetails.splice(poisition, 1);
  }

  getQuestionTemplateNumber(index: number) {
    const templateQuestions = this.importTemplate.importTemplateDetailModels;
    const templateIndex = templateQuestions[index];
    if (templateIndex.questionType === 'Omit') {
      return '';
    }
    return templateQuestions.filter((element, position) => position < (index + 1) && element.questionType !== 'Omit').length;
  }

  getQuestionChildTemplateNumber(index: number, position: number) {
    const templateQuestions = this.importTemplate.importTemplateDetailModels;
    const templateIndex = templateQuestions[index];
    const questionPosition = templateIndex.importTemplateDetails[position];
    if (templateIndex.questionType === 'Omit' || questionPosition.questionType === 'Omit') {
      return '';
    }
    return this.getQuestionTemplateNumber(index) + '.' + templateIndex.importTemplateDetails.filter(
      (element, obPosition) => obPosition < (position + 1) && element.questionType !== 'Omit').length;
  }

  isNoShowUngroupChildQuestion(detailParent: ImportTemplateDetailModel, index: number) {
    const child = detailParent.importTemplateDetails[index];
    return (this.workSpaceSelected && this.workSpaceSelected.id) || detailParent.questionType === 'Omit' || child.questionType === 'Omit';
  }

  openDialogSaveTemplate() {
    const temp = this.templateSelected ? this.templates.filter(template => template.id === this.templateSelected) : [];
    this.importTemplate.templateName = temp.length ? temp[0].templateName : 'New Template';
    this.isShowDialogSaveTemplate = true;
  }

  saveTemplate(isUpdate: boolean) {
    this.showLoader = true;
    this.importTemplate.clientId = this.selectedClient.id;
    this.importTemplate.userIds = this.selectedUserIds;
    if (this.selectedPermission) {
      this.importTemplate.permission = this.selectedPermission.value;
    }
    if (isUpdate) {
      const temp = this.templates.filter(template => template.id === this.templateSelected);
      this.importTemplate.templateName = temp.length ? temp[0].templateName : 'New Template';
      this.importTemplate.id = this.templateSelected;
    }
    this.importTemplateService.saveTemplate(this.importTemplate).subscribe(res => {
      this.showLoader = false;
      this.toasterService.pop('success', 'Save template success');
      if (!isUpdate) {
        this.templates.push(res);
        this.templates = this.templates.slice(1, this.templates.length).sort((a, b) => a.templateName && b.templateName
          && a.templateName.toLowerCase() > b.templateName.toLowerCase() ? 1 : -1);
        this.templates.unshift(Object.assign(new ImportTemplate(), {templateName: '(New From Master)', id: null}));
        this.templateSelected = res.id;
        this.importTemplate.id = null;
        this.importTemplate.templateName = null;
      }
    }, _ => {
      this.showLoader = false;
    });
    this.isShowDialogSaveTemplate = false;

  }

  isNotDisabledImportBtn() {
    let isValid = this.surveyModels && this.surveyModels.length
      && this.surveyModels.filter(survey => survey.isSelected).every(survey => survey.isValid);

    if (!this.workSpaceSelected || !this.workSpaceSelected.id) {
      isValid = isValid && !!(this.selectedPermission
        && (this.selectedPermission.value !== 'User'
        || (this.selectedUserIds && this.selectedUserIds.length)))
        && !!this.masterSurveyNameSelected;
    } else {
      isValid = isValid && !!(this.importOption
        && (this.importOption !== 'Replace' || !!this.masterSurveyNameSelected));
    }
    if(!this.isHideTemplate){
      isValid = isValid && this.templateSelected;
    }
    return isValid;
  }

  cancelDialogSaveTemplate() {
    this.importTemplate.templateName = '';
    this.isShowDialogSaveTemplate = false;
  }

  resetForm() {
    this.templateSelected = 0;
    this.files = [null];
    this.importTemplate = null;
    this.masterSurveyNameSelected = null;
    this.selectedPermission = null;
    this.selectedUserIds = [];
    this.surveyModels = [];
    this.importOption = null;
    this.translationFile = null;
    this.uploader.clearQueue();
    this.showTranslationFile = false;
    this.isHideLanguage = true;
    this.responseTranslationKey = null;
    this.responseTransKeyAndCsv = null;
    this.languageNames = [];
  }

  isAnalyzeWithWorkspaceSelected() {
    return (this.workSpaceSelected && this.workSpaceSelected.id)
      && this.importOption;
  }

  analyzeAndLoadQuestion() {
    if (((this.isAnalyzeWithWorkspaceSelected()
      || this.templateSelected
      || this.masterSurveyNameSelected) && this.files.length)
      && !this.isNoLoadAnalyze) {
      this.isNoLoadAnalyze = true;
      this.showLoader = true;
      const formData = new FormData();
      this.files.forEach(file => {
        if (file) {
          formData.append('file', file);
        }
      });
      formData.append('workspaceSurveyMasterId', this.workSpaceSelected && this.workSpaceSelected.id ? this.workSpaceSelected.id : '');
      formData.append('templateId', this.templateSelected ? this.templateSelected : '');
      formData.append('importOption', this.importOption);
      formData.append('masterSurveyName', this.masterSurveyNameSelected
        || !this.isReplaceSurvey() ? this.masterSurveyNameSelected : '');
      this.importCsvService.analyzeProcess(formData).subscribe(res => {
        this.showLoader = false;
        res.survey.forEach((item, index) => {
          this.surveyModels[index].isValid = item.isValid;
        });
        this.importTemplate = res.questionDetails;
        this.isNoLoadAnalyze = false;
        this.compareWithSourceOfTruth();
        if(!this.translationFile && this.hasTranslationKey){
          this.verifyAndLoadTranslationKey(null);
        }
      }, _ => {
        this.isNoLoadAnalyze = false;
      });
    }
  }

  getWorkspaceNameFromCSVFileName(csvFileName: string) {
    if (csvFileName && csvFileName.endsWith(this.fileCSVExtention)) {
      return csvFileName.substring(0, csvFileName.length - this.fileCSVExtention.length);
    }
    return csvFileName;
  }

  importAction() {
    if (this.workSpaceSelected && this.workSpaceSelected.id) {
      this.isShowConfirmImportDialog = true;
    } else {
      this.import();
    }
  }

  importCsvInvalidText() {
    if(this.isHideLanguage){
      if ((!this.workSpaceSelected || !this.workSpaceSelected.id) && !this.templateSelected) {
        return `Text for this question doesn't match master`;
      } else if (this.templateSelected) {
        return `Text for this question doesn't match selected template`;
      } else {
        return `Text for this question doesn't match existing survey`;
      }
    }else{
      return `Text or Response for this question doesn't match existing translation key`;
    }
  }

  getAnswerChoiceAlphaName(index: number) {
    return getAlphaCharFromIndex(index);
  }

  onChangeTemplateType(selectedType: any) {
    if(selectedType.value == TemplateType.EXISTING_TEMPLATE){
      this.isHideTemplate = false;
      this.isHideLanguage = true;
      this.onClickRemoveTranslationFile();
    }else if(selectedType.value == TemplateType.NEW_TEMPLATE){
      this.isHideTemplate = true;
      this.templateSelected = null;
      this.isHideLanguage = true;
      this.onClickRemoveTranslationFile();
      this.analyzeAndLoadQuestion();
    }else{
      this.isHideTemplate = true;
      this.templateSelected = null;
      this.analyzeAndLoadQuestion();
      this.isHideLanguage = false;
    }
  }

  onClickUploadCsv(){
    console.log("Entra upload csv");
    this.showSelectFiles = true;
    this.isMultipleUpload = true;
    this.acceptedFiles = this.fileCSVExtention;
    this.translationFile = null;
    this.responseTranslationKey = null;
    this.responseTransKeyAndCsv = null;
    this.languageNames = [];
    this.showTranslationFile = false;
  }

  onClickUploadTranslationKey(){
    this.showSelectFiles = true;
    this.isMultipleUpload = false;
    this.acceptedFiles = this.fileExcelExtention;
  }

  onClickRemoveTranslationFile(){
    this.translationFile = null;
    this.uploader.clearQueue();
    this.showTranslationFile = false;
    this.responseTranslationKey = null;
    this.responseTransKeyAndCsv = null;
    this.languageNames = [];
    if (this.uploader.queue) this.verifyCsvFiles(this.uploader.queue);
  }

  private verifyCsvFiles(fileValids: FileItem[]){
    const formData = new FormData();
    fileValids.forEach(file => formData.append('file', file._file));
    this.showLoader = true;
    this.importCsvService.getFileInfo(formData).subscribe(res => {
      res.forEach(element => {
        this.surveyModels.push(element);
      });
      this.showLoader = false;
      this.okSelectFilesDialog(true);
    }, _ => this.showLoader = false);
  }

  private verifyTranslationFile(fileValids: FileItem[]){
    if(fileValids && fileValids.length === 1){
      this.verifyAndLoadTranslationKey(fileValids[0]._file);
      this.okSelectFilesDialog(false);
    }
  }

  private verifyAndLoadTranslationKey(translationFile: File){
    const formData = new FormData();
      if(translationFile){
        formData.append("translationKeyFile",translationFile);
        formData.append("isUsedTranslationKey",JSON.stringify(true));
      } else {
        formData.append("isUsedTranslationKey",JSON.stringify(false));
        formData.append('workspaceSurveyMasterId', this.workSpaceSelected && this.workSpaceSelected.id ? this.workSpaceSelected.id : '');
      }

      this.showLoader = true;
      //Call service that verify the key file
      this.importCsvService.verifyTranslationKey(formData).subscribe(res => {
          this.responseTranslationKey = new ImportResponseTraslationKey();
          Object.assign(this.responseTranslationKey,res);
          //if the file is without errors
          if(this.responseTranslationKey.isValid){
            //Append the csv files in the form data
            this.files.forEach(file => formData.append('fileCsv', file));
            //Load the languages to be chosen
            this.languageNames = this.responseTranslationKey.languages.map(item => item.name);
            //Call service that verify the key file and the Csv
            this.importCsvService.verifyTranslationKeyAndCSV(formData).subscribe(res2 => {
              this.responseTransKeyAndCsv = new ImportResponseTraslationKey();
              Object.assign(this.responseTransKeyAndCsv,res2);
              if(this.responseTransKeyAndCsv.isValid){
                this.isHideLanguage = false;
                //Assign languages
                this.assignLanguages();
                //validate file
                this.validateFile(this.responseTranslationKey.countQuestions);
              } else {
                Object.assign(this.responseTranslationKey,res2);
                this.isHideLanguage = false;
                //Assign languages
                this.assignLanguages();
                //validate file
                this.validateFile(this.responseTranslationKey.countQuestions);
              }
            },
            _ => this.showLoader = false
            );
          }else{
            this.errorTitle = "Invalid File Format";
            this.errorMessage = "Invalid translation key file. The contents of the file are in an unexpected format.";
            this.showPopupError = true;
            if (this.uploader.queue) this.verifyCsvFiles(this.uploader.queue);
          }
          this.showLoader = false;
        },
        _ => this.showLoader = false
      );
  }

  downloadAsCsv(responseTranslation: ImportResponseTraslationKey) {
    if(responseTranslation && !responseTranslation.isValid){
      const headers = new Headers({
        'Content-Type': 'text/csv'
      });
      let data = "File Name,Row,Column,Error\r\n";
      if(responseTranslation.errorLogs && responseTranslation.errorLogs.length > 0){
        const _logs = responseTranslation.errorLogs.sort((a, b) => Number(a.row) - Number(b.row))
        for(let i=0; i < _logs.length; i++){
          let auxErrorLog = _logs[i];
          data = data + auxErrorLog.fileName + "," + auxErrorLog.row + "," + auxErrorLog.column + "," + auxErrorLog.error + "\r\n";
        }
      }
      this.downloadFile(data);
    }
  }

  downloadFile(data) {
    let blob = new Blob(['\ufeff' + data], { type: 'attachment/csv' });
    let url = window.URL.createObjectURL(blob);

    if(navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'report.csv');
    } else {
        let a = document.createElement('a');
        a.href = url;
        a.download = 'report.csv';
        document.body.appendChild(a);
        a.click();        
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }
  //This method will assign the language if the backend could found it
  private assignLanguages(){
    if(this.responseTransKeyAndCsv && this.responseTransKeyAndCsv.surveyLanguages && this.responseTransKeyAndCsv.surveyLanguages.length > 0){
      if(this.surveyModels && this.surveyModels.length > 0){
        for(let i=0;i<this.responseTransKeyAndCsv.surveyLanguages.length;i++){
          let auxLanguage = this.responseTransKeyAndCsv.surveyLanguages[i];
          if(auxLanguage && auxLanguage.language && auxLanguage.language.name){
            for(let j=0;j<this.surveyModels.length;j++){
              let auxSurvey = this.surveyModels[j];
              if(auxLanguage.version === auxSurvey.name){
                auxSurvey.languageId = auxLanguage.language.id;
                auxSurvey.languageName = auxLanguage.language.name;
                break;
              }
            }
          }
        }
      }
    }
  }

  isAllowImportTypeForm(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportTypeForm && this.client.typeFormActivated));
  }

  isAllowImportSurveyMonkey(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportSurveyMonkey && this.client.surveyMonkeyActivated));
  }

  isAllowImportCSV(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportCSV));
  }

  onFileClick(event) {
    event.target.value = '';
  }

  //This method will put the validation on each file if there is any invalid file
  private validateFile(numQuestionsTranslKey: number){
    if(this.responseTransKeyAndCsv && this.responseTransKeyAndCsv.questionsByVersion && this.responseTransKeyAndCsv.questionsByVersion.length > 0){
      if(this.surveyModels && this.surveyModels.length > 0){
        for(let i=0;i<this.responseTransKeyAndCsv.questionsByVersion.length;i++){
          let auxFile = this.responseTransKeyAndCsv.questionsByVersion[i];
          if(auxFile){
            for(let j=0;j<this.surveyModels.length;j++){
              let auxSurvey = this.surveyModels[j];
              if(auxFile.version === auxSurvey.name){
                auxSurvey.isValid = auxFile.isValid && (numQuestionsTranslKey === auxFile.questions.length);
                break;
              }
            }
          }
        }
      }
    }
  }

  //This method will put the validation on each question if there is any invalid question or response
  private validateQuestions(surveySelected: SurveyCSVModel){
    if(this.responseTransKeyAndCsv && this.responseTransKeyAndCsv.questionsByVersion && this.responseTransKeyAndCsv.questionsByVersion.length > 0){
      if(this.importTemplate && this.importTemplate.importTemplateDetailModels && this.importTemplate.importTemplateDetailModels.length > 0){
        for(let i=0;i<this.responseTransKeyAndCsv.questionsByVersion.length;i++){
          let auxFile = this.responseTransKeyAndCsv.questionsByVersion[i];
          if(auxFile && auxFile.version === surveySelected.name){
            for(let j=0;j<this.importTemplate.importTemplateDetailModels.length;j++){
              let questionDetail = this.importTemplate.importTemplateDetailModels[j];
              for(let k=0;k<auxFile.questions.length;k++){
                let questionAux = auxFile.questions[k];
                if(j === k){
                  questionDetail.isNotValid = !questionAux.isValidQuestion || !questionAux.isValidResponse;
                  break;
                }
              }
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/import-csv/import-csv.component.ts